import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {RGiftVoucherData} from '../model/r-gift-voucher-data';
import {MBulkGiftVoucherCustomer} from '../../m-gift-voucher-bulk-customer/model/m-bulk-gift-voucher-customer-dto';
import {MGiftVoucher} from '../model/m-gift-voucher';
import {AppSettings} from '../../../settings/app-settings';

@Injectable()
export class MGiftVoucherService {

  constructor(private http: HttpClient) {
  }

  //save gift voucher
  public save(mGiftVoucher: RGiftVoucherData): Observable<RGiftVoucherData> {
    return this.http.post<RGiftVoucherData>(AppSettings.API_ENDPOINT + '/api/v1/gflock-main-service/master-files/m-gift-voucher/create-gift-voucher', mGiftVoucher);
  }

  //find only create gift vouchers by price category and bulk customer
  public findOnlyCreateByPriceCategoryAndBulkCustomer(giftVoucherPriceCategory: number, giftVoucherBulkCustomer: number): Observable<MGiftVoucher[]> {
    return this.http.get<MGiftVoucher[]>(AppSettings.API_ENDPOINT + '/api/v1/gflock-main-service/master-files/m-gift-voucher/find-only-create-gift-vouchers-price-category-and-bulk-customer/' + giftVoucherPriceCategory + '/' + giftVoucherBulkCustomer);
  }

  //find only create gift vouchers by price category and branch
  public findOnlyCreateByPriceCategoryAndBranch(giftVoucherPriceCategory: number, branch: number): Observable<MGiftVoucher[]> {
    return this.http.get<MGiftVoucher[]>(AppSettings.API_ENDPOINT + '/api/v1/gflock-main-service/master-files/m-gift-voucher/find-only-create-gift-vouchers-price-category-and-branch/' + giftVoucherPriceCategory + '/' + branch);
  }
}



// WEBPACK FOOTER //
// ./src/app/view/master-files/m-gift-voucher/service/m-gift-voucher.service.ts